import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { SkillTreeService } from '../skill-tree-by-course/skill-tree.service';
import { ELearningService } from './e-learning.service';

@Component({
  selector: 'app-e-learning',
  templateUrl: './e-learning.component.html',
  styleUrls: ['./e-learning.component.scss']
})
export class ELearningComponent implements OnInit {
  allCourse = [];
  selectedType: string = 'all';

  page = 1;
  pageSize = 12;
  collectionSize: number;
  rows: any[];

  constructor(
    private router: Router,
    private elearningService: ELearningService,
    private skillTreeService: SkillTreeService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    if (this.selectedType !== 'skilltree') {
      this.elearningService.getAllCourse(this.selectedType).subscribe(res => {
        // // console.log(res);
        this.allCourse = res.result;
        this.refresh();
      })
    } else {
      this.skillTreeService.getAllSkillTree().subscribe(res => {
        // // console.log(res);
        this.allCourse = [...new Set(res.result)];
        this.refresh();
      })
    }
    this.gobalFunctionService.setSEO('คอร์สเรียน E-learning', 'website', '');
  }

  viewCourse(courseId) {
    this.router.navigate(['e-learning/' + courseId]);
  }

  changeType() {
    if (this.selectedType !== 'skilltree') {
      this.elearningService.getAllCourse(this.selectedType).subscribe(res => {
        this.allCourse = res.result;
        // // console.log(this.allCourse);

        this.refresh();
      })
    } else {
      this.skillTreeService.getAllSkillTree().subscribe(res => {
        this.allCourse = res.result;
        this.refresh();
      })
    }
  }

  onFaverite(id, isFavorite) {
    const body = {
      COURSE_ID: id,
      FAVORITE: !isFavorite
    }

    this.elearningService.favoriteCourse(body).pipe(
      switchMap(() => {
        return this.elearningService.getAllCourse(this.selectedType).pipe(
          map(res => {
            this.allCourse = res.result;
            this.refresh();
          })
        )
      }),
      catchError((err) => {
        alert(err.error.message)
        return of(null);
      })
    ).subscribe();
  }

  refresh() {
    this.collectionSize = this.allCourse.length;
    this.rows = this.allCourse
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
